/**
 * cart-item
 */

import store from 'js/lib/Store';
import counter from '~/counter/counter';

export default {
  props: {
    product: {
      type: Object
    }
  },
  data() {
    return {
      amount: this.product.amount
    };
  },
  store,
  components: {
    counter
  },
  computed: {
    total() {
      return this.amount * this.product.price;
    }
  },
  methods: {
    calc() {
      this.$emit('update', this.amount);
    },
    remove(id) {
      store.dispatch('removeProduct', id);
    },
    updateAmount({ amount }) {
      this.amount = amount;
    }
  },
  template: '#cart-item-template'
};
